import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { UserAuthProvider } from "@/context/UserAuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Kesfet from "@/pages/Kesfet";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Kutuphane from "@/pages/Kutuphane";
import KutuphaneDetail from "@/pages/KutuphaneDetail";
import Kurumlar from "@/pages/Kurumlar";
import Hakkimizda from "@/pages/Hakkimizda";
import Store from "@/pages/Store";
import Search from "@/pages/Search";
import NotFound from "@/pages/NotFound";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import Account, { ProtectedUser } from "@/pages/Account";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout, { ProtectedRoute } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LeadManager from "@/pages/admin/LeadManager";
import ContentManager from "@/pages/admin/ContentManager";
import ProgramManager from "@/pages/admin/ProgramManager";
import EventManager from "@/pages/admin/EventManager";
import NewsletterList from "@/pages/admin/NewsletterList";
import Settings from "@/pages/admin/Settings";
import ProductManager from "@/pages/admin/ProductManager";
import OrderManager from "@/pages/admin/OrderManager";
import UserManager from "@/pages/admin/UserManager";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <UserAuthProvider>
          <CartProvider>
            <AuthProvider>
              <Toaster position="bottom-right" richColors />
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/kesfet" element={<Kesfet />} />
                  <Route path="/programlar" element={<Programs />} />
                  <Route path="/programlar/:slug" element={<ProgramDetail />} />
                  <Route path="/kutuphane" element={<Kutuphane />} />
                  <Route path="/kutuphane/:slug" element={<KutuphaneDetail />} />
                  <Route path="/kurumlar" element={<Kurumlar />} />
                  <Route path="/hakkimizda" element={<Hakkimizda />} />
                  <Route path="/magaza" element={<Store />} />
                  <Route path="/arama" element={<Search />} />
                  <Route path="/etkinlikler" element={<Events />} />
                  <Route path="/etkinlikler/:slug" element={<EventDetail />} />
                  <Route path="/magaza/:slug" element={<ProductDetail />} />
                  <Route path="/sepet" element={<Cart />} />
                  <Route path="/odeme" element={<Checkout />} />
                  <Route path="/odeme-sonucu" element={<PaymentResult />} />
                  <Route path="*" element={<NotFound />} />
                </Route>

                <Route path="/giris" element={<Login />} />
                <Route path="/kayit" element={<Register />} />
                <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
                <Route path="/sifre-sifirla" element={<ResetPassword />} />
                <Route path="/eposta-dogrula" element={<VerifyEmail />} />
                <Route path="/hesabim" element={<ProtectedUser><Account /></ProtectedUser>} />
                <Route path="/hesabim/:section" element={<ProtectedUser><Account /></ProtectedUser>} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<Dashboard />} />
                  <Route path="orders" element={<OrderManager />} />
                  <Route path="products" element={<ProductManager />} />
                  <Route path="users" element={<UserManager />} />
                  <Route path="leads" element={<LeadManager />} />
                  <Route path="content" element={<ContentManager />} />
                  <Route path="programs" element={<ProgramManager />} />
                  <Route path="events" element={<EventManager />} />
                  <Route path="newsletter" element={<NewsletterList />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </AuthProvider>
          </CartProvider>
        </UserAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
